<template>
  <MyAccountProfileLinksMobile
    v-if="isMobileOrTablet"
    :whatsapp-number-link="whatsappNumberLink"
  />
  <MyAccountProfileLinksDesktop
    v-else
    :whatsapp-number-link="whatsappNumberLink"
  />
</template>

<script setup lang="ts">
const { isMobileOrTablet } = useDevice()
const { store } = useDomainState()
const whatsappNumberLink = computed(() => {
  return (
    'https://wa.me/' +
    useWhatsappNumer(
      false,
      store.value || undefined
    )
  )
})
</script>
